import * as $ from "jquery";

/**
 * This validation method is used for a very specific case and should not be used in a broader application.
 * This is a workaround for very specific problem in the 2nd stage of the Bodzio cart process
 */
export const CustomDepartmentIdRules = (() => {
    $.validator.addMethod("customDepartmentIdValidate", function(value, element, param) {
        if(param.DeliveryRadioButton.prop('checked') === false){
            return true;
        }
        if(value !== ""){
            return true;
        }
        return false;
    },
    $.validator.format("Proszę wybrać salon odbioru osobistego"));
})();import * as $ from "jquery";

/**
 * This validation method is used for a very specific case and should not be used in a broader application.
 * This is a workaround for very specific problem in the 2nd stage of the Bodzio cart process
 */
export const CustomDepartmentIdRules = (() => {
    $.validator.addMethod("customDepartmentIdValidate", function(value, element, param) {
        if(param.DeliveryRadioButton.prop('checked') === false){
            return true;
        }
        if(value !== ""){
            return true;
        }
        return false;
    },
    $.validator.format("Proszę wybrać salon odbioru osobistego"));
})();